import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { LOADING_CIRCLE, Status } from 'common/utils/constants';

const ActionTwoHopProgressTableOverlay = (props) => {
  const twoHopProgressStatusName = `GET-TwoHopAlignmentStatusInstances-${props.alignmentId}`;
  const twoHopProgressStatus = useSelector((store) => store.statuses[twoHopProgressStatusName]);
  let overlay = null;
  if (
    twoHopProgressStatus === Status.FAILURE &&
    (props.twoHopStatusInstanceDictionary == null || Object.keys(props.twoHopStatusInstanceDictionary)?.length === 0)
  ) {
    overlay = (
      <div id="Global_Table_ErrorOverlay" className="Global_Table_ErrorOverlay">
        <div id="Global_Table_Error_Div" className="Global_Table_Error_Div">
          <div id="Global_Table_ErrorOverlay_Title" className="Global_Table_ErrorOverlay_Title">
            Error{' '}
          </div>
          <div id="Global_Table_ErrorOverlay_Message" className="Global_Table_ErrorOverlay_Message">
            An unexpected problem occurred and this data is unavailable. Please try refreshing the page, and if the
            problem persists, contact us at
            <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
          </div>
        </div>
      </div>
    );
  } else if (twoHopProgressStatus === Status.PENDING && !props.isGetTwoHopAlignmentCalled) {
    overlay = LOADING_CIRCLE;
  } else if (twoHopProgressStatus === Status.NONE && Object.keys(props.twoHopStatusInstanceDictionary)?.length === 0) {
    overlay = (
      <div id="ActionTwoHopProgressTable_NoData" className="ActionTwoHopProgressTable_NoData">
        There are no records for these devices.
      </div>
    );
  }

  return overlay;
};

export default ActionTwoHopProgressTableOverlay;
